// src/App.js
import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Impo
import PrivateRoute from './components/PrivateRoute';
import ChangePassword from './pages/ChangePassword';
import ForgotPassword from './pages/ForgotPassword';
import FunctionalDepartmentForm from './pages/Functional Department/FunctionDepartmentForm';
import FunctionDepartmentList from './pages/Functional Department/FunctionDepartmentList';
import Login from './pages/Login';
import PermissionForm from './pages/Permission/PermissionForm';
import PermissionList from './pages/Permission/PermissionList';
import ResetPassword from './pages/ResetPassword';
import AboutPage from './pages/about/About';
import CompanyForm from './pages/company/CompanyForm';
import CompanyList from './pages/company/CompanyList';
import DepartmentForm from './pages/department/DepartmentForm';
import DepartmentList from './pages/department/DepartmentList';
import EventDepartment from './pages/events/EventDepartment';
import EventForm from './pages/events/EventForm';
import EventList from './pages/events/EventList';
import AmbulanceTracker, { AmbulancePage } from './pages/gps/AmbulanceTracker';
import GpsUnitForm from './pages/gps/GpsUnitForm';
import GpsUnitList from './pages/gps/GpsUnitList';
import AllotedItemForm from './pages/item_deliveries/AllotedItemForm';
import LocationStructure from './pages/locationStructure/LocationStructure';
import DeliveredItemForm from './pages/item_deliveries/DeliveredItemForm';
import InwardForm from './pages/item_deliveries/InwardForm';
import InwardItemList from './pages/item_deliveries/InwardItemList';
import OutWardItem from './pages/item_deliveries/OutwardItem';
import PWAPickupForm from './pages/item_deliveries/PWAPickupForm';
import PickupForm from './pages/item_deliveries/PickupForm';
import UserEntry from './pages/item_deliveries/UserEntry';
import ItemDeliveryLogForm from './pages/item_delivery_logs/ItemDeliveryLogForm';
import ItemDeliveryLogList from './pages/item_delivery_logs/ItemDeliveryLogList';
import ItemTypeForm from './pages/item_types/ItemTypeForm';
import ItemTypeList from './pages/item_types/ItemTypeList';
import ItemForm from './pages/items/ItemForm';
import ItemList from './pages/items/ItemList';
import StaionReport from './pages/reports/StationReport';
import RoleForm from './pages/roles/RoleForm';
import RoleList from './pages/roles/RoleList';
import StationTypeForm from './pages/station_types/StationTypeForm';
import StationTypeList from './pages/station_types/StationTypeList';
import StationForm from './pages/stations/StationForm';
import StationList from './pages/stations/StationList';
import StationMap from './pages/stations/StationMap';
import Supervisor from './pages/supervisor/Supervisor';
import SupervisorForm from './pages/supervisor/SupervisorForm';
import UserRoleEventForm from './pages/user_role_events/UserRoleEventForm';
import UserRoleEventList from './pages/user_role_events/UserRoleEventList';
import UserForm from './pages/users/UserForm';
import UserList from './pages/users/UserList';
import VolunteerForm from './pages/volunteers/VolunteerForm';
import VolunteerList from './pages/volunteers/VolunteerList';
import AmbulanceMap from './pages/map/AmbulanceMap';
import MapSidebar from './pages/map/MapSidebar';
import MapHistory from './pages/map/MapHistory';
import ControlRoomChat from './chat/ControlRoomChat';
import SCChat from './chat/SCChat';

function App() {
  return (
    <Router>
      <ToastContainer position='top-right' />
      <Routes>
        <Route path='/login' element={<Login />} />
        <Route path='/' element={<Login />} />

        <Route path='/forgot-password' element={<ForgotPassword />} />
        <Route path='/reset-password/:token' element={<ResetPassword />} />
        <Route element={<PrivateRoute />}>
          <Route path='change-password' element={<ChangePassword />} />

          <Route path='/events' element={<EventList />} />
          <Route path='/events/new' element={<EventForm />} />
          <Route path='/events/edit/:id' element={<EventForm />} />
          <Route path='/eventDepartments' element={<EventDepartment />} />

          <Route path='/vendor' element={<CompanyList />} />
          <Route path='/vendor/new' element={<CompanyForm />} />
          <Route path='/vendor/edit/:id' element={<CompanyForm />} />

          <Route path='/user-role-events' element={<UserRoleEventList />} />
          <Route path='/user-role-events/new' element={<UserRoleEventForm />} />
          <Route
            path='/user-role-events/edit/:id'
            element={<UserRoleEventForm />}
          />
          <Route path='/roles' element={<RoleList />} />
          <Route path='/role/new' element={<RoleForm />} />
          <Route path='/role/edit/:id' element={<RoleForm />} />

          <Route
            path='/functionalDepartments'
            element={<FunctionDepartmentList />}
          />
          <Route
            path='/functionalDepartment/new'
            element={<FunctionalDepartmentForm />}
          />
          <Route
            path='/functionalDepartment/edit/:id'
            element={<FunctionalDepartmentForm />}
          />

          <Route path='/permissions' element={<PermissionList />} />
          <Route path='/permission/new' element={<PermissionForm />} />
          <Route path='/permission/edit/:id' element={<PermissionForm />} />

          <Route path='/item-types' element={<ItemTypeList />} />
          <Route path='/item-types/new' element={<ItemTypeForm />} />
          <Route path='/item-types/edit/:id' element={<ItemTypeForm />} />

          <Route path='/users' element={<UserList />} />
          <Route path='/users/new' element={<UserForm />} />
          <Route path='/users/edit/:id' element={<UserForm />} />

          <Route path='/permission' element={<PermissionList />} />
          <Route path='/permission/new' element={<PermissionForm />} />
          <Route path='/permission/edit/:id' element={<PermissionForm />} />

          <Route path='/items-type' element={<ItemTypeList />} />
          <Route path='/items-type/new' element={<ItemTypeForm />} />
          <Route path='/items-type/edit/:id' element={<ItemTypeForm />} />

          <Route path='/items' element={<ItemList />} />
          <Route path='/items/new' element={<ItemForm />} />
          <Route path='/items/edit/:id' element={<ItemForm />} />

          <Route path='/station-types' element={<StationTypeList />} />
          <Route path='/station-types/new' element={<StationTypeForm />} />
          <Route path='/station-types/edit/:id' element={<StationTypeForm />} />

          <Route path='/stations' element={<StationList />} />
          <Route path='/stations/new' element={<StationForm />} />
          <Route path='/stations/edit/:id' element={<StationForm />} />
          <Route path='/stations-map' element={<StationMap />} />

          <Route path='/alloted-items' element={<AllotedItemForm />} />
          <Route path='/location-structure' element={<LocationStructure />} />
          {/* <Route path='/alloted-items/new' element={<AllotedItemForm />} />
          <Route path='/alloted-items/edit/:id' element={<AllotedItemForm />} /> */}

          <Route path='/inward-items' element={<InwardItemList />} />
          <Route path='/inward-items/new' element={<InwardForm />} />
          <Route path='/inward-items/edit/:id' element={<InwardForm />} />

          <Route path='/picked-up-items' element={<PickupForm />} />
          {/* <Route path='/picked-up-items/new' element={<PickupForm />} />
          <Route path='/picked-up-items/edit/:id' element={<PickupForm />} /> */}

          <Route path='/departments' element={<DepartmentList />} />
          <Route path='/department/new' element={<DepartmentForm />} />
          <Route path='/department/edit/:id' element={<DepartmentForm />} />

          <Route path='/delivered-items' element={<DeliveredItemForm />} />
          {/* <Route path='/delivered-items/new' element={<DeliveredItemForm />} />
          <Route
            path='/delivered-items/edit/:id'
            element={<DeliveredItemForm />}
          /> */}

          <Route path='/item-delivery-logs' element={<ItemDeliveryLogList />} />
          <Route
            path='/item-delivery-logs/new'
            element={<ItemDeliveryLogForm />}
          />
          <Route
            path='/item-delivery-logs/edit/:id'
            element={<ItemDeliveryLogForm />}
          />

          <Route path='/stationUpdate' element={<Supervisor />} />

          {/* <Route path='/attendance' element={<AttendanceForm />} />
          <Route path='/attendances' element={<AttendanceList />} /> */}

          <Route path='/volunteer/new' element={<VolunteerForm />} />
          <Route path='/volunteer/edit/:id' element={<VolunteerForm />} />
          <Route path='/volunteers' element={<VolunteerList />} />

          <Route path='/stationReport' element={<StaionReport />} />

          {/* <Route path='/ambulance-map' element={<AmbulanceMap />} /> */}

          <Route path='/gpsUnits' element={<GpsUnitList />} />
          <Route path='/gpsUnitForm' element={<GpsUnitForm />} />
          <Route path='/gpsUnitForm/:id' element={<GpsUnitForm />} />

          <Route path='/ambulance/:id' element={<AmbulancePage />} />
          <Route path='/delivered-item' element={<OutWardItem />} />
          <Route path='/userAccess' element={<UserEntry />} />
          <Route path='/stockHistory' element={<SupervisorForm />} />
          <Route path='/station-delivery' element={<PWAPickupForm />} />

          <Route path='/about' element={<AboutPage />} />

          <Route path='/map' element={<AmbulanceMap />} />
          <Route path='/incidents' element={<MapSidebar />} />
          <Route path='/map-history' element={<MapHistory />} />
          <Route path='/control-room-chat' element={<SCChat />} />
          <Route path='/view-control-room-chat' element={<SCChat />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
